// selectedStateReducer.js
import { SET_SELECTED_STATE, SET_SELECTED_LGA } from './action';

const initialState = {
  selectedState: null,
  selectedLGA: null,
};

const selectedStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_STATE:
      return {
        ...state,
        selectedState: action.payload,
        selectedLGA: null, // Reset selectedLGA when state changes
      };
    case SET_SELECTED_LGA:
      return {
        ...state,
        selectedLGA: action.payload ? action.payload : null, // Ensure LGA has an id
      };
    default:
      return state;
  }
};

export default selectedStateReducer;
